import React from 'react';
import { Clipboard, Sparkles, Expand, FolderOpen } from 'lucide-react';
import useEmblaCarousel from 'embla-carousel-react';

const features = [
  {
    icon: <Clipboard className="w-6 h-6" />,
    title: "Frictionless capture",
    description: "Paste anything. Links, images, notes, docs. No filing required."
  },
  {
    icon: <Sparkles className="w-6 h-6" />,
    title: "Smart search", 
    description: "AI understands what you saved, not just what you typed. Find things you forgot you had."
  },
  {
    icon: <Expand className="w-6 h-6" />,
    title: "Spatial thinking",
    description: "Drag items onto an infinite canvas. See connections. Think visually."
  },
  {
    icon: <FolderOpen className="w-6 h-6" />,
    title: "Instant collections",
    description: "Auto-organize into boards. Or don't. Your call."
  }
];

export const Features = () => {
  const [emblaRef] = useEmblaCarousel({ 
    align: 'start',
    containScroll: 'trimSnaps',
  });

  return (
    <section className="py-20 px-6 sm:px-10 lg:px-16">
      <div className="max-w-5xl mx-auto">
        {/* Desktop view - 2x2 grid */}
        <div className="hidden sm:grid md:grid-cols-2 gap-6 lg:gap-8">
          {features.map((feature, i) => (
            <div key={i} className="p-6 lg:p-8 rounded-2xl bg-white shadow-sm border border-border/30 hover:shadow-md transition-shadow">
              <div className="w-12 h-12 rounded-xl bg-[#ff5c35]/10 flex items-center justify-center text-[#ff5c35] mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
        
        {/* Mobile view - swipeable carousel */}
        <div className="sm:hidden">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-4">
              {features.map((feature, i) => (
                <div key={i} className="flex-[0_0_85%] min-w-0">
                  <div className="p-6 rounded-2xl bg-white shadow-sm border border-border/30 h-full">
                    <div className="w-12 h-12 rounded-xl bg-[#ff5c35]/10 flex items-center justify-center text-[#ff5c35] mb-4">
                      {feature.icon}
                    </div>
                    <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                    <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Carousel dots indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {features.map((_, i) => (
              <div key={i} className="w-2 h-2 rounded-full bg-[#ff5c35]/30" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
